/* eslint-disable import/prefer-default-export */
const select = (state) => state.campaigns

export const isLoading = (store) => select(store).campaignInfoLoading
